<script lang="ts" setup>
import Countdown from '../atoms/Countdown.vue'
import Loader from '../atoms/Loader.vue'

export interface Props {
  message?: string
  qr?: string
  more?: string
  t?: (key?: string) => string
  showLoader?: boolean
}

withDefaults(defineProps<Props>(), {
  message: '',
  qr: '',
  more: '',
  t: () => '',
  showLoader: true,
})
</script>

<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white">
    <div class="flex flex-col items-center">
      <Loader v-if="showLoader" />
      <h2
        :class="[
          'mt-2 text-center font-serif text-2xl font-bold leading-none lg:text-5xl lg:leading-snug',
          showLoader ? 'text-blue' : 'text-black',
        ]"
        :level="2"
      >
        {{ message || t('spinner.message') }}
      </h2>
      <p v-if="more" class="mt-2 text-center font-sans text-base text-black lg:text-xl">
        {{ more }}
      </p>
      <img v-if="qr" :src="qr" class="mt-4 h-64 w-64" />
      <div v-if="qr">
        <Countdown class="font-semibold" />
      </div>
    </div>
  </div>
</template>
